import { useEffect, useState } from "react";
import { useTaskpaneServices } from "@src/load-agent/app/TaskpaneServicesContext";

export function useOfficeItemMeta() {
  const { office } = useTaskpaneServices();
  const [subject, setSubject] = useState<string>("");
  const [createdDate, setCreatedDate] = useState<Date | null>(null);
  const [passedTime, setPassedTime] = useState<string>("");

  useEffect(() => {
    try {
      const meta = office.getItemMeta();

      if (!meta) return;
      let s = meta.subject || "";

      if (s.length > 19) s = s.substring(0, 15) + "...";
      setSubject(s);
      setCreatedDate(meta.createdDate);
      if (meta.createdDate) {
        const now = new Date();
        const diff = now.getTime() - meta.createdDate.getTime();
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const days = Math.floor(hours / 24);

        if (days > 0) {
          setPassedTime(`${days} day${days > 1 ? "s" : ""} ago`);
        } else if (hours > 0) {
          setPassedTime(`${hours} hour${hours > 1 ? "s" : ""} ago`);
        } else {
          setPassedTime("Just now");
        }
      }
    } catch (error) {
      void error;
    }
  }, [office]);
  return { subject, createdDate, passedTime };
}
